@for (toast of toastService.toasts; track toast) {
<ngb-toast [class]="toastService.getToastTypeClass(toast)" [header]="toastService.getToastHeader(toast)"
    [ariaLive]="'polite'" [autohide]="true" [delay]="toast.delay || toastService.delay"
    (hidden)="toastService.remove(toast)">
    {{toast.message}}
</ngb-toast>
}